import React from 'react'
import Img from 'gatsby-image'
import './PhotoRow.sass'

class PhotoRow extends React.Component {
  state = {
    full: null,
    loading: false
  }

  showFull = src => {
    this.setState( { full: src, loading: true } )
  }

  hideFull = () => {
    this.setState( { full: null, loading: true } )
  }

  imgLoaded = () => {
    this.setState( { loading: false } )
  }

  onKey = event => {
    if (event.keyCode === 27) this.hideFull()
  }

  onBackdropClick = event => {
    if (event.target === event.currentTarget) {
      this.hideFull()
    }
  }

  componentDidUpdate() {
    document.body.parentElement.style.overflow = this.state.full ? 'hidden' : ''
    if (this.state.full) {
      document.body.addEventListener('keyup', this.onKey)
    } else {
      document.body.removeEventListener('keyup', this.onKey)
    }
  }

  componentWillUnmount() {
    document.body.removeEventListener( 'keyup', this.onKey );
  }

  render() {
    const { images, height, titles } = this.props
    const style = { height: height || '' }

    return (
      <div className="PhotoRow" style={style}>
        {images.map( ( { node }, i ) =>
          <div
            tabIndex={0}
            key={node.name}
            className="PhotoRow-item"
            onClick={() => this.showFull( node.publicURL )}
          >
            <div className="PhotoRow-img" style={{ backgroundImage: `url(${node.childImageSharp.resize.src})` }} />
            <div className="PhotoRow-title">
              <span>{titles[i]}</span>
            </div>
          </div>
        )}
        {this.state.full &&
          <div className="PhotoRow-FullScreen" onClick={this.onBackdropClick}>
            {this.state.loading && <span className="spinner" />}
            <img
              className={this.state.loading ? null : 'is-loaded'}
              src={this.state.full}
              onLoad={this.imgLoaded}
            />
            <button className="close" onClick={this.hideFull}>X</button>
          </div>
        }
      </div>
    )
  }
}

export default PhotoRow



// WEBPACK FOOTER //
// ./src/components/PhotoRow/index.js